import FetchResultWrapper from '../../../common/component/FetchResultWrapper';
import GridModule from '../../common/component/GridModule';
import GridModuleTitleV4 from '../../common/component/GridModuleTitleV4';
import HomeFooter from '../../common/component/HomeFooter';
import useRankingInfo from '../../common/hook/useRankingInfo';
import RankingContentList from '../component/RankingContentList';
import useMainListEventHandler from '../hook/useMainListEventHandler';

export default function RankingList() {
  const {
    handleClickBigContent,
    handleClickContent,
    sendViewImpBigContent,
    sendViewImpContent,
    handleClickPromotionVideo,
    handleClickPromotionVideoMute,
    handleClickPromotionVideoPlay,
  } = useMainListEventHandler();

  const {
    bigContent,
    contents,
    talkBoard,
    placement,
    isRankingInProgress,
    adminSectionList,
    rankingSectionTitle,
  } = useRankingInfo();

  return (
    <>
      {adminSectionList.map((item, index) => (
        <GridModule
          key={index}
          item={item}
          onClickBigContent={({content, index}) =>
            handleClickBigContent({item, content, index})
          }
          onClickContent={({content, index}) =>
            handleClickContent({item, content, index})
          }
          onSendViewImpBigContent={({content, index}) =>
            sendViewImpBigContent({item, content, index})
          }
          onSendViewImpContent={({content, index}) =>
            sendViewImpContent({item, content, index})
          }
          onClickPromotionVideo={({content, index}) =>
            handleClickPromotionVideo({item, content, index})
          }
          onClickPromotionVideoMute={(isMute, {content, index}) =>
            handleClickPromotionVideoMute(isMute, {item, content, index})
          }
          onClickPromotionVideoPlay={({content, index}) =>
            handleClickPromotionVideoPlay({item, content, index})
          }
        />
      ))}
      {adminSectionList.length > 0 && rankingSectionTitle && (
        <GridModuleTitleV4 className="mt-42" title={rankingSectionTitle} />
      )}
      <FetchResultWrapper
        showNoItems={isRankingInProgress}
        noItemsProps={{
          textKey: 'ranking_in_progress',
          className: 'py-[200px]',
          isFixed: false,
        }}
      >
        <RankingContentList
          bigContent={bigContent}
          contents={contents}
          talkBoard={talkBoard}
          placement={placement}
        />
      </FetchResultWrapper>
      {(adminSectionList.length > 0 || contents.length > 0 || !!bigContent) && (
        <HomeFooter className="-mt-1" />
      )}
    </>
  );
}
